import React, {
	ReactElement,
	useCallback,
	useEffect,
	useRef,
	useState,
} from "react";

interface IFlash {
	message: string;
	error: boolean;
}

/**
 * A message above the table. Successes fade after a few seconds; errors stay
 * until dismissed or replaced.
 */
export function useFlash() {
	const [flash, setFlash] = useState<IFlash | null>(null);
	const timer = useRef<number>();

	useEffect(() => () => window.clearTimeout(timer.current), []);

	const show = useCallback((message: string, error = false) => {
		window.clearTimeout(timer.current);
		setFlash({ message, error });
		if (!error) {
			timer.current = window.setTimeout(() => setFlash(null), 3000);
		}
	}, []);

	const element: ReactElement | null = flash && (
		<div
			className={`products-flash ${flash.error ? "is-error" : ""}`}
			role={flash.error ? "alert" : "status"}
		>
			<i
				className={`fa ${
					flash.error ? "fa-exclamation-circle" : "fa-check-circle"
				}`}
			/>{" "}
			{flash.message}
			{flash.error && (
				<button
					type="button"
					className="btn-close ms-auto"
					aria-label="Dismiss"
					onClick={() => setFlash(null)}
				/>
			)}
		</div>
	);

	return { show, element };
}
